export const SEARCH_INVOICES_BATCHES_LOADING = "app/SEARCH_INVOICES_BATCHES_LOADING";
export const SEARCH_INVOICES_BATCHES_RESULTS = "app/SEARCH_INVOICES_BATCHES_RESULTS";
export const SEARCH_INVOICES_BATCHES = "app/SEARCH_INVOICES_BATCHES";
export const INVOICES_BATCHES_CHANGE_PAGE = "app/INVOICES_BATCHES_CHANGE_PAGE";
export const CHANGE_PER_PAGE = "app/INVOICES_BATCHES_CHANGE_PER_PAGE";
